<template>
  <div class="manual-steps">
    <ManualStep :number="1">
      Откройте <br />
      <span class="step-subtitle">Dota 2</span>
    </ManualStep>
    <ManualStep :number="2">
      Нажмите <br />
      <span class="step-subtitle">«Игротека»</span>
    </ManualStep>
    <ManualStep :number="3">
      Введите <br />
      <span class="step-subtitle">River Runes</span>
    </ManualStep>
  </div>
</template>

<script>
import ManualStep from "./ManualStep";

export default {
  name: "ManualSteps",
  components: {
    ManualStep
  }
};
</script>

<style lang="scss">
.manual-steps {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 667px;
  background: url("~@/assets/img/manual/bg-rush.png") 50% 0 no-repeat;
  flex-wrap: wrap;
  margin-bottom: -50px;
  padding: 150px 0 70px;

  @include breakpoint("sm-and-down") {
    padding: 90px 0 70px;
  }
}

.step-subtitle {
  color: #fbc33e;
}
</style>
